import { ChangeEvent, useId } from 'react'
import { MatchCriteriaFilters } from '@/interfaces/match-criteria'
import FiltersBlock from '@/components/filters'

interface Props {
  className?: string
  filtersCollectionData: MatchCriteriaFilters[]
  handleCheckBoxChange: (e: ChangeEvent<HTMLInputElement>) => void
  filters: string[]
}

const FiltersCollection = ({
  className = '',
  filtersCollectionData,
  handleCheckBoxChange,
  filters,
}: Props) => {
  const id = useId()

  return (
    <div className={`filtersCollection ${className}`}>
      <h3 className="H2">Filter</h3>
      {filtersCollectionData.map((singleValue, index) => {
        return (
          <FiltersBlock
            key={`${id}-${singleValue.filterName}`}
            filtersTitle={singleValue.filterName}
            filterData={singleValue.filterData}
            handleCheckBoxChange={handleCheckBoxChange}
            filters={filters}
            isOpen={index === 0}
          />
        )
      })}
    </div>
  )
}

export default FiltersCollection
